import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="bg-[#F9F9F8] min-h-screen">
      <article className="max-w-3xl mx-auto px-6 py-16 prose-borrame">
        <div className="eyebrow text-red-600 mb-3">Ley 21.719 · Vigente desde 01-12-2026</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">
          Política de Privacidad
        </h1>
        <p className="mt-3 text-sm font-mono text-gray-500">
          Última actualización: 22 de febrero de 2026 · Vigencia: indefinida
        </p>

        <Section title="1. Identidad del responsable">
          <p>El responsable del tratamiento de los datos personales recolectados a través
          de este sitio es <b>borra-me.com SpA</b>, sociedad por acciones constituida bajo
          las leyes de la República de Chile, con domicilio en Santiago, Chile.</p>
          <ul>
            <li><b>Razón social:</b> borra-me.com SpA</li>
            <li><b>Domicilio comercial:</b> Santiago, Región Metropolitana, Chile</li>
            <li><b>Correo del Delegado de Protección de Datos (DPO):</b> <a href="mailto:privacidad@borra-me.com">privacidad@borra-me.com</a></li>
            <li><b>Correo de contacto general:</b> <a href="mailto:contacto@borra-me.com">contacto@borra-me.com</a></li>
          </ul>
        </Section>

        <Section title="2. Marco legal aplicable">
          <p>Esta política se rige por:</p>
          <ul>
            <li><b>Ley 21.719</b> sobre Protección de Datos Personales (vigente desde el 1 de diciembre de 2026), que moderniza la Ley 19.628 e incorpora los principios de licitud, lealtad, finalidad, calidad, proporcionalidad, transparencia, responsabilidad proactiva, seguridad y confidencialidad.</li>
            <li><b>Ley 19.628</b> sobre Protección de la Vida Privada, en lo aplicable durante la transición.</li>
            <li><b>Constitución Política de la República</b>, artículo 19 N° 4 (derecho a la protección de datos personales).</li>
          </ul>
        </Section>

        <Section title="3. Datos que recolectamos">
          <p>Solo recolectamos los datos estrictamente necesarios para la prestación del servicio. Los clasificamos en cuatro categorías:</p>
          <h3>3.1 Datos que <em>tú nos entregas</em></h3>
          <ul>
            <li><b>Nombre completo</b> y <b>RUT</b> — para identificarte ante los brokers y firmar tus solicitudes ARCOP.</li>
            <li><b>Correo electrónico y contraseña</b> — para crear y autenticar tu cuenta.</li>
            <li><b>Teléfono, dirección, comuna y región</b> — solo si los proporcionas en el onboarding, para personalizar tus solicitudes.</li>
            <li><b>Datos de pago</b> — procesados <u>íntegramente</u> por Webpay Transbank; nosotros no almacenamos tu número de tarjeta.</li>
          </ul>
          <h3>3.2 Datos que <em>generamos sobre ti</em></h3>
          <ul>
            <li>Resultados del escaneo de brokers (qué sitios contienen tus datos, qué campos exponen).</li>
            <li>Historial de solicitudes ARCOP enviadas y respuestas recibidas.</li>
            <li>Score de privacidad y métricas agregadas.</li>
          </ul>
          <h3>3.3 Datos técnicos (automáticos)</h3>
          <ul>
            <li>Dirección IP, navegador, sistema operativo, idioma y zona horaria.</li>
            <li>Logs de acceso (timestamp, endpoint, código HTTP).</li>
            <li>Cookies esenciales y, si nos das tu consentimiento, cookies analíticas (ver <Link to="/legal/cookies" className="underline">Política de Cookies</Link>).</li>
          </ul>
          <h3>3.4 Datos de terceros</h3>
          <p>Para verificar que tus datos efectivamente están publicados, consultamos APIs públicas y scrapeamos sitios de rutificadores. Estos datos provienen del propio broker (no de ti) y los exhibimos como evidencia, solo dentro de tu dashboard privado.</p>
        </Section>

        <Section title="4. Finalidades y base legal del tratamiento">
          <table className="w-full text-sm border-collapse border border-gray-200 my-4">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left">Finalidad</th>
                <th className="border border-gray-200 px-3 py-2 text-left">Base legal (Ley 21.719)</th>
                <th className="border border-gray-200 px-3 py-2 text-left">Conservación</th>
              </tr>
            </thead>
            <tbody>
              <tr><td className="border border-gray-200 px-3 py-2">Ejecutar tu solicitud ARCOP y eliminar tus datos de los brokers</td><td className="border border-gray-200 px-3 py-2">Consentimiento explícito + cumplimiento de la ley</td><td className="border border-gray-200 px-3 py-2">Mientras esté activa tu cuenta + 1 año (para auditoría)</td></tr>
              <tr><td className="border border-gray-200 px-3 py-2">Autenticarte y mantener tu sesión</td><td className="border border-gray-200 px-3 py-2">Ejecución de contrato</td><td className="border border-gray-200 px-3 py-2">Mientras esté activa la cuenta</td></tr>
              <tr><td className="border border-gray-200 px-3 py-2">Procesar pagos y emitir facturas</td><td className="border border-gray-200 px-3 py-2">Ejecución de contrato + obligación legal (SII)</td><td className="border border-gray-200 px-3 py-2">6 años (art. 17 CT)</td></tr>
              <tr><td className="border border-gray-200 px-3 py-2">Detectar fraude y abusos</td><td className="border border-gray-200 px-3 py-2">Interés legítimo</td><td className="border border-gray-200 px-3 py-2">12 meses (logs)</td></tr>
              <tr><td className="border border-gray-200 px-3 py-2">Comunicaciones transaccionales (confirmaciones, recordatorios D+5, denuncia APDP)</td><td className="border border-gray-200 px-3 py-2">Ejecución de contrato</td><td className="border border-gray-200 px-3 py-2">Mientras dure la solicitud + 1 año</td></tr>
              <tr><td className="border border-gray-200 px-3 py-2">Estadísticas y mejoras de producto (datos agregados)</td><td className="border border-gray-200 px-3 py-2">Interés legítimo</td><td className="border border-gray-200 px-3 py-2">Indefinido (sin identificadores)</td></tr>
            </tbody>
          </table>
        </Section>

        <Section title="5. Con quién compartimos tus datos">
          <p>Solo compartimos los datos estrictamente necesarios con los siguientes <b>encargados</b> (que actúan bajo contrato y nuestras instrucciones):</p>
          <ul>
            <li><b>Brokers chilenos</b> (findatos.com, nombrerutyfirma.com, etc.) — recibirán tu nombre y RUT en el cuerpo de la solicitud ARCOP, porque eso es exactamente lo que les pides eliminar.</li>
            <li><b>Resend</b> (proveedor SMTP, EE.UU.) — entrega los correos ARCOP. Transferencia con garantías contractuales adecuadas.</li>
            <li><b>Transbank (Webpay Plus)</b> — procesa los pagos con tarjeta.</li>
            <li><b>Google Cloud / MongoDB Atlas / proveedor de hosting</b> — almacenamiento técnico cifrado en reposo.</li>
            <li><b>Agencia de Protección de Datos Personales (APDP)</b> — solo si tú decides escalar formalmente una denuncia.</li>
          </ul>
          <p><b>Nunca vendemos, alquilamos ni cedemos tus datos para fines publicitarios.</b></p>
        </Section>

        <Section title="6. Tus derechos ARCOP (artículos 12 a 17)">
          <p>Como titular de los datos personales, tienes derecho a ejercer en cualquier momento y de manera gratuita:</p>
          <ul>
            <li><b>Acceso</b> — saber qué datos tuyos tenemos.</li>
            <li><b>Rectificación</b> — corregir datos incorrectos.</li>
            <li><b>Cancelación / supresión</b> — eliminar tus datos (“derecho al olvido”).</li>
            <li><b>Oposición</b> — oponerte a un tratamiento basado en interés legítimo.</li>
            <li><b>Portabilidad</b> — recibir una copia estructurada de tus datos.</li>
            <li><b>Limitación</b> — restringir temporalmente el tratamiento.</li>
            <li><b>No ser objeto de decisiones automatizadas</b> que produzcan efectos jurídicos.</li>
          </ul>
          <p><b>Cómo ejercerlos:</b> envía un correo a <a href="mailto:privacidad@borra-me.com">privacidad@borra-me.com</a> indicando tu solicitud y adjuntando una copia de tu cédula de identidad para validar tu identidad. Te responderemos en un plazo máximo de <b>30 días corridos</b> (art. 15 Ley 21.719).</p>
          <p>Si no estás conforme con nuestra respuesta, puedes reclamar directamente ante la <b>Agencia de Protección de Datos Personales (APDP)</b>.</p>
        </Section>

        <Section title="7. Seguridad">
          <p>Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos, incluyendo:</p>
          <ul>
            <li>Cifrado en tránsito (TLS 1.3) y en reposo (AES-256 sobre la base de datos).</li>
            <li>Contraseñas almacenadas con <b>bcrypt</b> + salt único por usuario.</li>
            <li>Tokens JWT en cookies httpOnly con flags <code>Secure</code> y <code>SameSite=Lax</code>.</li>
            <li>Acceso restringido a producción con MFA y registro de auditoría.</li>
            <li>Notificación de brechas a la APDP <i>sin dilaciones indebidas</i> (Ley 21.719 art. 25).</li>
          </ul>
        </Section>

        <Section title="8. Transferencias internacionales">
          <p>Algunos encargados están fuera de Chile (Resend en EE.UU., infraestructura en regiones de AWS/GCP). Estas transferencias se realizan con cláusulas contractuales estándar y solo a países con nivel adecuado de protección o con garantías equivalentes.</p>
        </Section>

        <Section title="9. Menores de edad">
          <p>El servicio no está dirigido a menores de 14 años. Si descubrimos que recolectamos datos de un menor sin el consentimiento de quien ejerce la patria potestad, los eliminaremos inmediatamente.</p>
        </Section>

        <Section title="10. Cambios a esta política">
          <p>Podemos actualizar esta política en cualquier momento. Te notificaremos los cambios sustantivos por correo electrónico y mantendremos visible la fecha de última actualización al inicio de este documento.</p>
        </Section>

        <Section title="11. Contacto del Delegado de Protección de Datos">
          <p>
            <b>borra-me.com SpA</b><br />
            Delegado de Protección de Datos<br />
            Email: <a href="mailto:privacidad@borra-me.com">privacidad@borra-me.com</a><br />
            Dirección: Santiago, Chile
          </p>
        </Section>

        <div className="mt-12 pt-6 border-t border-gray-200 text-xs font-mono text-gray-500">
          <p>borra-me.com SpA · Política conforme a la Ley 21.719 (Chile) · Versión 1.0</p>
          <p className="mt-1">Documentos relacionados: <Link to="/legal/cookies" className="underline">Política de Cookies</Link> · <Link to="/legal/terminos" className="underline">Términos y Condiciones</Link></p>
        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-display text-xl font-bold text-gray-900 border-l-2 border-[#E63946] pl-3 mb-3">
        {title}
      </h2>
      <div className="text-gray-700 leading-relaxed space-y-3 [&_a]:underline [&_a]:text-[#0B2447] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_h3]:font-display [&_h3]:font-semibold [&_h3]:text-gray-900 [&_h3]:mt-4 [&_h3]:text-base">
        {children}
      </div>
    </section>
  );
}
